import { toast, ToastOptions } from 'react-toastify';

export const handleError = (error: any, toastOptions?: ToastOptions) => {
  if (error instanceof Error) toast.error(error.message, toastOptions);
  else if (typeof error === 'string') toast.error(error, toastOptions);
  console.log(error);
};
